import { View } from 'react-native'

import { Placeholder, PlaceholderLine, PlaceholderMedia } from '@/src/elements/placeholder'
import { TEST_ID } from '@/src/general/constants/testId'

export const FeedItemPlaceholder = () => (
  <Placeholder
    testID={TEST_ID.PRAYER_SPACE.FEED_ITEM_PLACEHOLDER}
    className="mx-2 max-w-full flex-col gap-4 pl-4 md:mx-4"
  >
    <View className="w-full flex-row items-center">
      <PlaceholderMedia size="avatar-md" radius="full" />
      <PlaceholderLine size="lg" className="ml-4 flex-1" />
    </View>
    <PlaceholderLine contrast="dark" className="w-full h-24" />
    <View className="w-full flex-row items-center justify-between gap-2">
      <View className="flex-row items-center gap-2">
        <PlaceholderMedia size="avatar-md" radius="full" className="w-16" />
        <PlaceholderMedia size="avatar-md" radius="full" className="w-16" />
      </View>
      <PlaceholderMedia size="avatar-md" radius="full" className="w-32 justify-self-end" />
    </View>
  </Placeholder>
)
